var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Books")]), _vm._v(" "), _c('p', [_vm._v("Available book collection. You can select any book to request a trade. ")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "progress progress-striped active"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  })]) : _c('div', [(_vm.books && _vm.books.length > 0) ? [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.books), function(book) {
    return _c('div', {
      key: book._id,
      staticClass: "col-md-2 col-sm-3 col-xs-6"
    }, [_c('div', {
      staticClass: "book"
    }, [_c('div', {
      staticClass: "controls"
    }, [_c('i', {
      staticClass: "fa fa-exchange text-info",
      attrs: {
        "aria-hidden": "true",
        "title": "Request"
      },
      on: {
        "click": function($event) {
          _vm.tradeBook(book)
        }
      }
    })]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "thumbnail",
        "title": book.title,
        "src": book.thumbnail
      }
    })])])
  }))] : [_vm._m(0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/books-add"
    }
  }, [_vm._v("Click here")]), _vm._v(" to add books.\n    ")]], 2)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('h3', [_vm._v("Oops!")]), _vm._v(" "), _c('p', [_vm._v("No books found!")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06d6aa12","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/books.vue
// module id = 96
// module chunks = 0